module.exports = __webpack_public_path__ + "img/4.a3af79f3.jpg";